import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Menu, MenuItem, Stack, Typography } from '@mui/material';
import { Cancel, CheckCircleOutline, ChevronDown } from 'mdi-material-ui';
import { useState } from 'react';
const options = [
    {
        status: 'Approve',
        color: '#2F80ED',
    },
    {
        status: 'Reject',
        color: '#FF0000',
    },
];
const ApproveUploadButton = ({ approved, onClick }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [option, setOption] = useState(options[0]);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleSelect = (item) => {
        setOption(item);
        onClick(item.status);
        setAnchorEl(null);
    };
    return (_jsx(_Fragment, { children: approved === undefined ? (_jsxs(_Fragment, { children: [_jsx(Button, Object.assign({ variant: "outlined", size: "small", onClick: handleClick, sx: {
                        color: option.color,
                        fontWeight: 400,
                        borderRadius: '4px',
                        padding: '5px 16px',
                        borderColor: option.color,
                        '&.MuiButton-root: hover': {
                            borderColor: option.color,
                        },
                    }, endIcon: _jsx(ChevronDown, {}) }, { children: option.status })), _jsx(Menu, Object.assign({ anchorEl: anchorEl, open: open, onClose: () => setAnchorEl(null) }, { children: _jsx(Box, Object.assign({ sx: {
                            borderRadius: '8px',
                            boxShadow: '0px 0px 4px rgba(102, 102, 102, 0.25)',
                            margin: '4px',
                            p: '5px 0px',
                        } }, { children: options.map((item, index) => (_jsx(MenuItem, Object.assign({ sx: {
                                gap: 2,
                                fontSize: '14px',
                            }, onClick: () => handleSelect(item) }, { children: _jsx(Typography, Object.assign({ variant: "subtitle2", sx: { color: item.color } }, { children: item.status })) }), index))) })) }))] })) : (_jsxs(Stack, Object.assign({ direction: "row", alignItems: "center", spacing: 1 }, { children: [_jsx(Typography, Object.assign({ variant: "subtitle2", sx: { color: approved ? '#22A06B' : '#FF0000' } }, { children: approved ? ' Artwork Approved' : 'Artwork Rejected ' })), approved ? (_jsx(CheckCircleOutline, { sx: { fontSize: '14px', color: '#22A06B' } })) : (_jsx(Cancel, { sx: { fontSize: '14px', color: '#FF0000' } }))] }))) }));
};
export default ApproveUploadButton;
